"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Index = _interopRequireDefault(require("@superlogica/icon/src/Index"));

var _focus = _interopRequireDefault(require("@superlogica/superlogica-core/enum/focus"));

var _propTypes = require("prop-types");

var _Styled = require("./Styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Input = _react.default.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      color = _ref.color,
      icon = _ref.icon,
      label = _ref.label,
      marginTop = _ref.marginTop,
      marginRight = _ref.marginRight,
      marginBottom = _ref.marginBottom,
      marginLeft = _ref.marginLeft,
      message = _ref.message,
      name = _ref.name,
      _onBlur = _ref.onBlur,
      _onChange = _ref.onChange,
      _onFocus = _ref.onFocus,
      status = _ref.status,
      textColor = _ref.textColor,
      type = _ref.type,
      value = _ref.value,
      maxLength = _ref.maxLength,
      rest = _objectWithoutProperties(_ref, ["className", "color", "icon", "label", "marginTop", "marginRight", "marginBottom", "marginLeft", "message", "name", "onBlur", "onChange", "onFocus", "status", "textColor", "type", "value", "maxLength"]);

  var inputRef = ref || (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(_focus.default.default),
      _useState2 = _slicedToArray(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1];

  var _useState3 = (0, _react.useState)(value),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var statusClass = status;
  var classes = "".concat(className, " ").concat(statusClass);
  (0, _react.useEffect)(function () {
    setInputValue(value);
  }, [value]);
  return /*#__PURE__*/_react.default.createElement(_Styled.GenericDiv, _extends({
    color: color,
    textColor: textColor,
    icon: icon,
    margins: {
      t: marginTop,
      r: marginRight,
      b: marginBottom,
      l: marginLeft
    },
    className: classes,
    focus: focus,
    onFocus: function onFocus(data) {
      setFocus(_focus.default.focusOn);

      _onFocus(data);
    },
    onBlur: function onBlur() {
      setFocus(_focus.default.default);
    }
  }, rest), icon && /*#__PURE__*/_react.default.createElement(_Index.default, {
    className: "input-icon",
    name: icon
  }), /*#__PURE__*/_react.default.createElement(_Styled.InputType, {
    ref: inputRef,
    id: name,
    name: name,
    type: type,
    value: inputValue,
    maxLength: maxLength,
    icon: icon,
    onBlur: function onBlur(data) {
      _onBlur(data);
    },
    onChange: function onChange(e) {
      _onChange(e);
    },
    placeholder: " "
  }), /*#__PURE__*/_react.default.createElement(_Styled.Label, {
    htmlFor: name,
    focus: focus
  }, label), status === 'error' && /*#__PURE__*/_react.default.createElement(_Styled.Span, null, message));
});

Input.displayName = 'Input';
Input.propTypes = {
  className: _propTypes.string,
  color: _propTypes.string,
  floatingMessage: _propTypes.bool,
  icon: _propTypes.string,
  label: _propTypes.string,
  marginTop: _propTypes.string,
  marginRight: _propTypes.string,
  marginBottom: _propTypes.string,
  marginLeft: _propTypes.string,
  message: _propTypes.string,
  name: _propTypes.string,
  onChange: _propTypes.func,
  onBlur: _propTypes.func,
  onFocus: _propTypes.func,
  textColor: _propTypes.string,
  value: _propTypes.any,
  status: (0, _propTypes.oneOf)(['', 'error', 'success']),
  type: _propTypes.string,
  maxLength: _propTypes.number
};
Input.defaultProps = {
  color: 'neutral',
  floatingMessage: false,
  label: 'Informe um label',
  marginTop: 'none',
  marginRight: 'none',
  marginBottom: 'none',
  marginLeft: 'none',
  status: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {}
};
var _default = Input;
exports.default = _default;